export interface SweepingCapacityByPeriodDto {
  readonly timeUnit: "year" | "quarter" | "month" | "week";
  readonly time: number;
  readonly capacity: number;
}

/**
 * The number of flues that can be swept for a given time;
 */
export class SweepingCapacityByPeriod {
  readonly timeUnit: "year" | "quarter" | "month" | "week";
  readonly time: number;
  readonly capacity: number;

  constructor(args: {
    timeUnit: "year" | "quarter" | "month" | "week";
    time: number;
    capacity: number;
  }) {
    this.timeUnit = args.timeUnit;
    this.time = args.time;
    this.capacity = args.capacity;
  }

  withCapacity(value: number): SweepingCapacityByPeriod {
    return new SweepingCapacityByPeriod({
      timeUnit: this.timeUnit,
      time: this.time,
      capacity: value,
    });
  }

  toDto(): SweepingCapacityByPeriodDto {
    return {
      timeUnit: this.timeUnit,
      time: this.time,
      capacity: this.capacity,
    };
  }

  static fromDto(dto: SweepingCapacityByPeriodDto): SweepingCapacityByPeriod {
    return new SweepingCapacityByPeriod(dto);
  }
}
